import { Card, CardHeader, CardBody, PageError, PageLoading } from "../components/index.js";
import { useApi } from "../hooks/useApi.js";

/**
 * Client-facing "Our Services" tab. Read-only view of the client-visible
 * knowledge fields (contracted services, renewal date, goals) for the
 * logged-in user's own client. The backend endpoint is scoped to req.clientId
 * and returns ONLY client-visible fields — no brand notes, internal notes, or
 * revenue data ever reach this page.
 */
export function OurServices() {
  const { data, loading, error, reload } = useApi("/api/dashboard/our-services");
  const fields = data?.fields || [];

  if (error) return <PageError error={error} onRetry={() => reload()} />;
  if (loading) return <PageLoading />;

  return (
    <div className="max-w-[820px]">
      <Card>
        <CardHeader
          title="Our Services"
          subtitle="What we're delivering for you"
        />
        <CardBody>
          {fields.length === 0 ? (
            <div className="py-6 text-[13px] text-text-muted">
              Your service details haven't been published yet. Your Bayshore contact will have these available soon.
            </div>
          ) : (
            <dl className="space-y-5">
              {fields.map((f) => (
                <div key={f.key}>
                  <dt className="text-[10px] uppercase text-text-muted font-medium mb-1" style={{ letterSpacing: "0.5px" }}>
                    {f.label}
                  </dt>
                  <dd className="text-[13px] text-text-primary whitespace-pre-wrap leading-relaxed">{f.value}</dd>
                </div>
              ))}
            </dl>
          )}
        </CardBody>
      </Card>
    </div>
  );
}
